
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/post-event-resources",
      function () {
        return require("private-next-pages/sa/post-event-resources.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/post-event-resources"])
      });
    }
  